import React from "react";
import styled from "styled-components";
import { PortalSurface } from "./BusinessPortalComponents";
import { desktop } from "./Media";

const OuterContainer = styled.div`
    width: 100%;
    max-width: ${p => p.maxWidth || "98.625rem"};
    min-width: 0;
    height: ${p => p.height || "auto"};
    min-height: ${p => p.minHeight || "auto"};
    margin-top: ${p => p.marginTop || 0};
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    row-gap: 0;
    column-gap: ${p => p.columnGap || p.gap || "1rem"};
    box-sizing: border-box;

    ${desktop`
        flex-direction: row;
        align-items: stretch;
    `};
`;

const InnerContainer = styled(PortalSurface)`
    flex: 1 1 ${p => p.width || "0"};
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    min-width: 0;
    max-width: ${p => p.maxWidth || "none"};
    min-height: 0;
    overflow: ${p => p.overflow || "visible"};

    ${desktop`
        width: ${p => p.width || "100%"};
    `};
`;

function TwoColumnLayout(props) {
    const {
        children,
        leftContainerWidth,
        rightContainerWidth,
        leftBorder,
        rightBorder,
        leftMaxWidth,
        rightMaxWidth,
        ...styleProps
    } = props;
    const childArray = React.Children.toArray(children);
    
    if (childArray.length !== 2) {
        const myMessage = "TwoColumnLayout requires 2 children; " + childArray.length + " found";
        throw Object.assign(
            new Error(myMessage),
            { code: 402 }
        );
    }
    return (
        <OuterContainer {...styleProps}>
            <InnerContainer width={leftContainerWidth} 
                maxWidth={leftMaxWidth}
                border={leftBorder}
            >
                { childArray[0] }
            </InnerContainer>
            <InnerContainer width={rightContainerWidth} 
                maxWidth={rightMaxWidth}
                border={rightBorder}
            >
                { childArray[1] }
            </InnerContainer>
        </OuterContainer>
    );
}

export default TwoColumnLayout;
